import { useState, useEffect } from "react";
// routing
import Routes from "routes";

// project imports
import Locales from "ui-component/Locales";
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "ui-component/RTLLayout";
import Snackbar from "ui-component/extended/Snackbar";
import ThemeCustomization from "themes";
// import store from "./store/index"
import { loadUser } from "./store/slices/userLoginAction";
import { store, persister } from "store";
import { getLabelsName, getLabelVersion } from "./store/slices/labelAction";

import setAuthToken from "Helpers/setAuthToken";
import { PersistGate } from "redux-persist/integration/react";
// auth provider
// import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

if (localStorage.ownerAppToken) {
  setAuthToken(localStorage.ownerAppToken);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
    store.dispatch(getLabelVersion());
  }, []);
  return (
    <ThemeCustomization store={store}>
      <PersistGate loading={null} persistor={persister}>
        <RTLLayout>
          <Locales>
            <NavigationScroll>
              <>
                <Routes />
                <Snackbar />
              </>
            </NavigationScroll>
          </Locales>
        </RTLLayout>
      </PersistGate>
    </ThemeCustomization>
  );
};

export default App;
